export default __webpack_public_path__ + "static/media/yarden_truck_back.3809bab7.jpg";